// package imports
// antd v5 renders message/notification/Modal statics via ReactDOM internals that
// React 19 removed - this official patch restores them. Remove with the antd v6 upgrade.
import '@ant-design/v5-patch-for-react-19';
import ReactDOM from 'react-dom/client';
import { RouterProvider } from 'react-router/dom';
import { setAutoFreeze, enablePatches } from 'immer';
import FontFaceObserver from 'fontfaceobserver';
import '@fontsource/noto-sans';
import amplitude from 'amplitude-js';

// Local Imports
import { router } from './route';
import './index.css';
import 'mapbox-gl/dist/mapbox-gl.css';
import { customLogger } from './utils/common';
import './i18n/config.ts';

const font = new FontFaceObserver('Noto Sans');

font
  .load()
  .then(() => {
    customLogger('Noto Sans has loaded.');
  })
  .catch(() => {
    customLogger('Noto Sans failed to load.');
  });
setAutoFreeze(false);
enablePatches();
if (import.meta.env.PA_AMPLITITUDE_KEY) {
  amplitude.getInstance().init(import.meta.env.PA_AMPLITITUDE_KEY);
}
// Get the root element
const rootElement: HTMLElement | null = document.getElementById('root');
if (rootElement) {
  const env = import.meta.env.PA_ENV_NAME as string;
  const appVersion = import.meta.env.PA_REACT_APP_VERSION;
  const buildVersion = import.meta.env.PA_REACT_APP_BUILD_VERSION;

  customLogger('Selected Environment', { env, appVersion, buildVersion });
  const root = ReactDOM.createRoot(rootElement);
  root.render(<RouterProvider router={router} />);
} else {
  console.error('Root element not found in the document');
}
